import { createSelector } from "@reduxjs/toolkit";

import { Alert } from "./reducer";

export const getAlertsState = (state: any) => state.alerts;
export const getAlertsData = createSelector(
   getAlertsState,
   (alerts) => alerts.alerts as Alert[],
);
